<template>
  <v-row dense>
    <v-col
        cols="12"
        sm="4"
        v-for="item in items"
        :key="item.id"
    >
      <v-list-item
          class="border"
          style="text-decoration: none;"
          @click="$emit('close'); $router.push('/banktransfer/'+item.id+'?item='+item.id)"
          :to="'/banktransfer/'+item.id+'?item='+item.id"
      >
        <v-list-item-content>
          <v-list-item-title class="font-weight-black blue--text">{{item.base_currency}}{{item.amount | toMoney}}</v-list-item-title>

          <v-list-item-subtitle>
            From:{{item.from_account.account_name}}
          </v-list-item-subtitle>
          <v-list-item-subtitle>
            To:{{item.to_account.account_name}}
          </v-list-item-subtitle>

          <v-list-item-subtitle>
            Description:{{item.description}}
          </v-list-item-subtitle>

        </v-list-item-content>
      </v-list-item>

    </v-col>
    <v-col cols="12" sm="4">
      <v-card outlined tile>
        <v-card-text>
          <v-btn
              large
              text
              rounded
              color="blue"
              to="/banktransfer"
              block
              @click="$emit('close'); $router.push('/banktransfer')"
          >Go to Bank Transfers <v-icon>mdi-arrow-right</v-icon></v-btn>

        </v-card-text>
      </v-card>
    </v-col>

  </v-row>

</template>

<script>
export default {
  props:['items'],
  name: "SearchTransfers"
}
</script>

<style scoped>

</style>